import React from "react";
import { SvgWeb } from "../../../public/images/svg/SvgWeb";
import { CastleIcon } from "../../icons";
import { CreateFile, getPlaceTypeLabel } from "@ac-expo/api-types";
import { PlaceType } from "@prisma/client";
import OwnImage from "@ui/components/ui/event/OwnImage";
import { useFileUrlGetter } from "@web-app/src/shared/files";

interface CardPlaceProps {
  city: string;
  name: string;
  location: string | null;
  image: CreateFile | undefined;
  type: PlaceType;
}

const CardPlace: React.FC<CardPlaceProps> = ({
  name,
  location,
  image,
  type,
}) => {
  const { getFileUrl } = useFileUrlGetter();
  const imageUrl = getFileUrl(image?.key, image?.type, 425);

  return (
    <div className="flex w-full flex-col gap-1">
      <div className="relative h-[120px] w-full overflow-hidden rounded-lg">
        <OwnImage
          src={imageUrl || "/images/place.jpeg"}
          alt="Lieu touristique"
        />
        <div className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-white px-2">
          <CastleIcon width={14} height={14} fill={"#287BB9"} />
          <p className="text-base text-gray-600">{getPlaceTypeLabel(type)}</p>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-semibold">{name}</h3>
        <div className="flex items-center gap-1 text-sm font-semibold text-gray-600">
          <SvgWeb name={"mapIn"} alt={"mapIn"} width={16} height={16} />
          {location}
        </div>
      </div>
    </div>
  );
};

export default CardPlace;
